import { render, staticRenderFns } from "./fuwenben.vue?vue&type=template&id=3ca179ce&scoped=true&"
import script from "./fuwenben.vue?vue&type=script&lang=js&"
export * from "./fuwenben.vue?vue&type=script&lang=js&"
import style0 from "./fuwenben.vue?vue&type=style&index=0&id=3ca179ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca179ce",
  null
  
)

export default component.exports